import { render, staticRenderFns } from "./WarehouseProducts.vue?vue&type=template&id=7806aaf1&scoped=true&"
import script from "./WarehouseProducts.vue?vue&type=script&lang=js&"
export * from "./WarehouseProducts.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseProducts.vue?vue&type=style&index=0&id=7806aaf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7806aaf1",
  null
  
)

export default component.exports